module.exports = __webpack_public_path__ + "img/logo.866cba7a.png";